// extracted by mini-css-extract-plugin
export default {"animation":"PageAnimation_animation__wdQpC","enter-from-left":"PageAnimation_enter-from-left__FUBb4"};